import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";

// OIDC config for AWS Cognito
const oidcConfig = {
  authority: import.meta.env.VITE_PUBLIC_AWS_COGNITO_AUTH_CONFIG_DOMAIN,
  client_id: import.meta.env.VITE_PUBLIC_AWS_COGNITO_AUTH_CONFIG_CLIENT_ID,
  redirect_uri: import.meta.env
    .VITE_PUBLIC_AWS_COGNITO_AUTH_CONFIG_REDIRECT_URI,
  response_type: import.meta.env
    .VITE_PUBLIC_AWS_COGNITO_AUTH_CONFIG_RESPONSE_TYPE,
  scope: import.meta.env.VITE_PUBLIC_AWS_COGNITO_AUTH_CONFIG_SCOPE,
};

// Check if any values are missing
const missingVars = [];
if (!oidcConfig.authority) missingVars.push("authority");
if (!oidcConfig.client_id) missingVars.push("client_id");
if (!oidcConfig.redirect_uri) missingVars.push("redirect_uri");

// Required for Apollo
if (typeof window !== "undefined" && !window.global) {
  window.global = window;
}

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
